

import { RegistereRibbonButton, useAppInfo, useModelDrivenApp, useModelDrivenGridViewerContext, useModelDrivenViewContext, useRibbon, useSelectionContext } from "@eavfw/apps";
import { useEAVForm } from "@eavfw/forms";
import { useClientContext, useJsonFetcher } from "@eavfw/manifest";
import { useBoolean } from "@fluentui/react-hooks";
import {
    Button,
    Dialog, DialogActions,
    DialogBody,
    DialogContent,
    DialogSurface,
    DialogTitle,
    DialogTrigger
} from "@fluentui/react-components";
import { Spinner } from "@fluentui/react";
import { runWorkflow } from "@eavfw/utils";
import { useRouter } from "next/router";

RegistereRibbonButton("CUSTOM_RIBBON_APPROVE_LOI", ({ key, ...props }) => {
    const { registerButton, events } = useRibbon();
    const { currentEntityName, currentRecordId } = useAppInfo();
    const { baseUrl } = useClientContext();
    const router = useRouter();
    const { mutate} = useModelDrivenViewContext();
   
    const app = useModelDrivenApp();
    const [_baseUrl, fetcher] = useJsonFetcher();
    const { selection, selectionDetails } = useSelectionContext();

    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [isLoading, { toggle: doneLoading, setTrue:setLoading }] = useBoolean(true);
    let [status] = typeof currentRecordId !== "undefined" ? useEAVForm(x => x.formValues.status) : [selection?.getSelection()[0]?.status];

    console.log("selectionDetails: ", selectionDetails);

    registerButton({
        key: key,
        showOnCard: true,
        text: props.text,
        iconProps: props.iconProps ?? { iconName: 'Send' },
        title: props.title ?? props.text,
        disabled: status  !== 30 || (selection?.getSelectedCount() ?? 2) > 1,
        onClick: () => {
            toggleHideDialog();
            doneLoading();
        }
    }, [status,selectionDetails]);


    return <>
        <Dialog open={!hideDialog}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>Approve the LOI and send to Charterers for signature</DialogTitle>
                    <DialogContent>
                       I confirm that I have read and approved the LOI.
                    </DialogContent>
                    <DialogActions fluid>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary" onClick={toggleHideDialog}>Close</Button>
                        </DialogTrigger>
                        <Button
                            appearance="primary"
                            disabled={isLoading}
                            onClick={async () => {
                                setLoading();
                                let { result, rsp } = await runWorkflow("ApproveLetterOfIndemnityRequestWorkflow", "Manual", { recordId: selection?.getSelection()[0].id });

                                if (result?.body?.status === "ok") {

                                }

                                mutate();
                                toggleHideDialog();
                                router.reload();
                            }}>
                            {isLoading ? <Spinner /> : 'Send'}
                        </Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    </>

});